import script from "./PreviewBulkUploadComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewBulkUploadComponent.vue?vue&type=script&lang=ts&setup=true"

import "./PreviewBulkUploadComponent.vue?vue&type=style&index=0&id=02896332&lang=css"

const __exports__ = script;

export default __exports__